import DeleteEleveFromGroup from '../AdminEleve/DeleteEleveFromGroup';

/**
 * Ligne du tableau élèves — LECTURE SEULE (spec GAR §0.7) : l'identité vient de
 * l'import établissement, plus d'édition ni de suppression ici. Seule action
 * restante : retirer l'élève d'un GROUPE (gestion de groupes, hors référentiel).
 */
export const TableRowEleve = ({ eleve, getClassementEleve, listEleves, handleRowClick, resultats,
    getPositionIcon, calculerMoyenne, getNbEval, classeNom, groupNom, handleMessagePost, setListEleves, handleReload
  }) => {
     const classement = getClassementEleve(eleve, listEleves);
     const isEleveGAR = eleve.synchronise_gar && eleve.eleve_gar;
const displayNom = isEleveGAR ? eleve.eleve_gar_nom : eleve.nom;
const displayPrenom = isEleveGAR ? eleve.eleve_gar_prenom : eleve.prenom;
    return(
      <tr key={eleve.id} data-id={eleve.id} className=" xl:text-lg text-sm hover:bg-blue-200
      hover:backdrop-blur-sm transition-all duration-200 cursor-pointer group bg-white" onClick={() => handleRowClick(eleve)}>
         <td className="p-3">
        <div className="font-semibold text-gray-800">{displayNom}</div></td>
         <td className="p-3">
        <div className="font-semibold text-gray-800">{displayPrenom}</div></td>
        {(classeNom[0] === '6' || classeNom[0] === '5') && (
           <td className="p-3">
        <span className="bg-gradient-to-r from-green-500 to-teal-500 text-white px-2 py-1 rounded-xl xl:text-base font-medium">
          {eleve.groupe_nom ? eleve.groupe_nom : "Aucun"}</span></td>
        )}
            {(groupNom) && (
            <td className="p-3">
        <span className="bg-orange-500 text-white px-2 py-1 rounded-xl xl:text-base font-medium">{eleve.classe_nom}</span></td>
        )}
        <td className="px-5 py-5 border-b border-gray-200 xl:text-lg text-blue-600 font-semibold">
          {eleve.resultats && eleve.resultats.length > 0
            ? calculerMoyenne(eleve)
            : "Pas de note."}
        </td>
        <td className="px-5 py-5 border-b border-gray-200 xl:text-lg">
          {eleve.resultats && eleve.resultats.length > 0
            ? getNbEval(eleve)
            : "0"}
        </td>
         <td className="px-5 py-5 border-b border-gray-200 text-sm">
          {resultats[eleve.id+eleve.nom + eleve.prenom] && (
              <div className="flex items-center h-5 bg-white rounded border border-gray-200 overflow-hidden shadow-sm">
              {/* Vert + */}
              <div className="bg-green-800 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].vertplus / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>

              {/* Vert */}
              <div className="bg-green-500 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].vert / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>
              {/* Presque maitrisé */}
              <div className="bg-teal-200 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].teal / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>

              {/* Presque maitrisé */}
              <div className="bg-yellow-500 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].yellow / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>

              {/* Orange */}
              <div className="bg-orange-400 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].orange / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>

              {/* Rouge */}
              <div className="bg-red-600 h-6" style={{ width: `calc(100% * ${resultats[eleve.id+eleve.nom + eleve.prenom].rouge / resultats[eleve.id+eleve.nom + eleve.prenom].total})` }}></div>
            </div>
          )}
        </td>
        <td className="p-3">
       {classement ?
        <div className="bg-gray-100 px-2 py-1 rounded-lg xl:text-sm text-xs text-gray-600 text-center">
        { getPositionIcon(classement.rang)} {classement.rang} sur {listEleves.length}
        </div>
        : <div className="bg-gray-100 px-2 py-1 rounded-lg xl:text-sm text-xs text-gray-600 text-center">
        Non classé
        </div>
  }
      </td>
       {groupNom ?
        <td>
          {/* Si on est dans un groupe, on affiche toujours DeleteEleveFromGroup, même pour les élèves GAR */}
          <DeleteEleveFromGroup eleve={eleve} setMessagePost={handleMessagePost} setListEleves={setListEleves} handleReload={handleReload}/>
        </td>
        :
        <td className="py-4 px-4 border-b">
          {isEleveGAR ? (
            <div className="flex justify-center">
              <span className="bg-blue-600 text-white text-sm font-bold px-3 py-1.5 rounded-md">
                GAR
              </span>
            </div>
          ) : null}
        </td>
    }
      </tr>
  )}
